import React from 'react';
import './App.css';
import { createGlobalStyle } from 'styled-components';
import globalStyle from './components/globalStyle';
import styledNormalize from 'styled-normalize';
import { Theme, variables } from '@generationtux/component-library';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import WelcomePage from './pages/Welcome';
import DataPage from './pages/Data';
import LookBuilder from './pages/LookBuilder';
import Looks from './pages/Looks';

const GlobalStyle = createGlobalStyle`
  ${styledNormalize}
  ${globalStyle}
  html {
    background: ${props => variables(props).grayLight};
  }
`;

const App = () => {
  return (
    <BrowserRouter>
      <Theme brand="gentux">
        <GlobalStyle />

        <Switch>
          <Route path="/data">
            <DataPage />
          </Route>
          <Route path="/look-build">
            <LookBuilder />
          </Route>
          <Route path="/looks">
            <Looks />
          </Route>
          <Route path="/">
            <WelcomePage />
          </Route>
        </Switch>
      </Theme>
    </BrowserRouter>
  );
};

export default App;
